const DataAnalysisPage = () => {
    return <div className="page max-h-[calc(100%-5.25rem)]"></div>;
};

export default DataAnalysisPage;
